var React = require('react');

function CheckBoxIndeterminate (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("rect",{"width":"16","height":"16","fill":"#0088BF","rx":"2","key":0}),React.createElement("path",{"fill":"#FFF","d":"M3 7h10v2H3z","key":1})]));
}

CheckBoxIndeterminate.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16"};

module.exports = CheckBoxIndeterminate;

CheckBoxIndeterminate.default = CheckBoxIndeterminate;
